import { IconArrowRight, IconChevronRight } from '@tabler/icons-react';
import { WP_ICON_NAV } from '@wapharma/design-system';
import styles from './InboxDrillableHint.module.css';

/** Caret → arrow on parent `[data-inbox-drillable]` hover/focus. */
export function InboxDrillableHint() {
  return (
    <span className={styles.hint} aria-hidden>
      <IconChevronRight {...WP_ICON_NAV} className={`${styles.icon} ${styles.caret}`} />
      <IconArrowRight {...WP_ICON_NAV} className={`${styles.icon} ${styles.arrow}`} />
    </span>
  );
}
